import clsx from "classnames"
import React from "react"
import { useTranslations } from "modules/i18n/hooks/useTranslations"
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig"
import { donationsUrl } from "../donationsUrl"
import { usePageProps } from "common/hooks/data/usePageProps"
import type { AppProps } from "common/lib/getAppServerSideProps"

const FAKE_BUTTON_STYLING = clsx(
  "min-hitbox-44 box-border inline-block max-w-40 grow items-center rounded-full p-2 sm:hidden lg:px-5 lg:py-2",
  "text-center text-xs font-bold text-white visited:text-white hover:text-white",
)

export const ActionButtons = () => {
  const t = useTranslations("layout.header")
  const { regionCode } = usePageProps<AppProps>()
  const regionConfig = useRegionConfig()
  const { stay_informed, donations } = regionConfig

  return (
    <div className="m-4 flex">
      {donations.enabled && !donations.promoted && (
        <a
          href={donationsUrl({ regionConfig, regionCode, campaign: "mobile-menu" })}
          className={clsx(FAKE_BUTTON_STYLING, "bg-red-600 hover:bg-red-500")}
        >
          {t("donate")}
        </a>
      )}
      {donations.promoted && stay_informed.enabled && (
        <a
          href={stay_informed.topbar.url}
          className={clsx(FAKE_BUTTON_STYLING, "bg-black hover:bg-black")}
        >
          {t("get_newsletter")}
        </a>
      )}
    </div>
  )
}
